import { ETC_TYPE, ETF_TYPE, STOCK_TYPE } from "@helpers/constants";

export function isDerivative(assetGroup: string): boolean {
	const group = assetGroup.toUpperCase();

	return group === STOCK_TYPE || group === ETF_TYPE || group === ETC_TYPE;
}
